export {default as AppModel} from './AppModel';



// WEBPACK FOOTER //
// ./src/models/index.js